<template>
  <div>
    <div v-if="flag">
      <slot :list="list"></slot>
    </div>
  </div>
</template>
<script>
  import getMenuService from '@/services/bylBaseCenter/menu'
  export default {
    data() {
      return {
        flag: false,
        list: []
      }
    },
    mounted () {
      getMenuService.getMenuListByRole({isShow: '1'}).then((r) => {
        function iteration (data, level) {
          level++
          for (var j = 0; j < data.length; j++) {
            data[j].opened = false // 菜单是否打开
            data[j].active = false // 是否高亮
            data[j].level = level
            data[j].redirectTo = data[j].href
            if (data[j].children != undefined && data[j].children.length > 0) {
              iteration(data[j].children, level)
            }
          }
        }
        iteration(r.data, 0)
        this.list = r.data
        this.list.forEach((o) => {
          if (o.href == this.$route.path) {
            o.active = true // 当前菜单点亮
            if (o.children) {
              o.opened = true
            }
          }
        })
        this.flag = true
      })
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/containers/menu/containerGetMenusByRole.vue